import React from 'react';
import "./HandsOnLab.css";
export default function HandsOnLab(){
    return(
<div className='experience-container'>
    <h1>HANDS ON LAB</h1>
    <ul type="square" className='ul-container'>
        <li>Experience during my coursework includes basic conceptual clarity of JavaScript, CSS and HTML.</li>
        <li>Have done 60+ programs to develop logics and programming concepts</li>
        <li>Designed responsive webpages like HTML forms, GitHub profile page, pagination using DOM, HTML, CSS and Bootstrap.</li>
        <li>Fetched data from API servers using fetch and asynchronized functions.</li>
        <li>Designed webpages using React.js and designed DB Models using SQL.</li>
        <li>Can do queries for SQL and MongoDB.</li>
        <li>Can fetch data from MongoDB using Atlas, create express server and create API in Node JS and can perform CRUD operations also.</li>
        <li>Confident in frontend, backend development and deploying sites using Netlify, Heroku, Render and Vercel.</li>
        <li>Based on a screening test on AWS, got an opportunity among the top 25 students from GUVI and achieved certification for completion of "AWS Technical Essentials" training.<a href="https://drive.google.com/uc?export=view&id=1eX4fOmTzOH-V8JIp8HpRiVdqX2aV4XYi" target="_blank">View Certificate</a></li>
        <li>Basic knowledge about data structure and algorithms.</li>
        <li>Basic understanding of Test Driven Development.</li>
    </ul>
</div>
    );
}